import { Grid, withTheme } from '@material-ui/core';
import range from 'lodash/range';
import React from 'react';
import GolfGroupInput from '../atom/GolfGroupInput';
import FancySelectButton from './FancySelectButton';
import { UserIcon } from '../../icons';

const GUEST_ALL_BUTTONS = [1, 2, 3, 4];
const LARGE_GROUP_START = GUEST_ALL_BUTTONS[GUEST_ALL_BUTTONS.length - 1] + 1;
const LARGE_GROUP_LIMIT = 40;

function FancyPlayerCountSelect({ value, setValue, label, theme }) {
    return (
        <Grid item container className="golf-options" justifyContent="center">
            <Grid item container spacing={1} className="mb-2">
                {GUEST_ALL_BUTTONS.map((val, index) => (
                    <Grid
                        key={val}
                        item
                        xs={6}
                        container
                        justifyContent={index % 2 === 0 ? 'flex-end' : 'flex-start'}
                        alignItems="center"
                    >
                        <Grid item>
                            {index <= 1 && <p>{index === 0 ? label : '\u00a0'}</p>}
                            <FancySelectButton
                                highlight={val === value}
                                onClick={() => setValue(val)}
                            >
                                {range(val).map(i => (
                                    <UserIcon
                                        style={{ color: theme.palette.primary.main }}
                                        key={`${val}-${i}`}
                                    />
                                ))}
                            </FancySelectButton>
                        </Grid>
                    </Grid>
                ))}
            </Grid>
            <Grid item container justifyContent="center" alignItems="center">
                <GolfGroupInput
                    largeGroupLimit={LARGE_GROUP_LIMIT}
                    largeGroupStart={LARGE_GROUP_START}
                    currentNumber={value}
                    onChangeNumber={setValue}
                    label={label}
                />
            </Grid>
        </Grid>
    );
}

export default withTheme(FancyPlayerCountSelect);
